import { Planner } from '../../planner.dto';
import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';
import { PlanningDetails } from '../planning-details.dto';

export class InspectionIntegrationDesignDto extends InspectionCase {
  safetyConsultant?: Planner;
  documents?: PlanningDetails;
  riskLevel?: InspectionValueCase;
  structureDescription?: InspectionValueCase;
  areas?: InspectionValueCase;
}

export class InspectionIntegrationDesign extends InspectionIntegrationDesignDto {
  constructor(
    data: InspectionIntegrationDesignDto = {
      title: 'תכנון',
      isApplicable: true
    }
  ) {
    super(data);
    this.safetyConsultant = data.safetyConsultant || new Planner();
    this.documents = new PlanningDetails(data.documents);
    this.riskLevel = new InspectionValueCase({
      ...data.riskLevel,
      title: 'האתר הנבדק מסווג ברמת סיכון'
    });
    this.structureDescription = new InspectionValueCase({
      ...data.structureDescription,
      title: 'תאור המבנה'
    });
    this.areas = new InspectionValueCase({
      ...data.areas,
      title: 'האזורים שנבדקו במסגרת בדיקה זו הינם'
    });
  }

  setInspectionStatus(): void {
    this.documents.setInspectionStatus();
    this.isPassed =
      !this.isApplicable ||
      ((!this.documents.isApplicable || this.documents.isPassed) &&
        (!this.riskLevel.isApplicable || this.riskLevel.isPassed) &&
        (!this.structureDescription.isApplicable ||
          this.structureDescription.isPassed) &&
        (!this.areas.isApplicable || this.areas.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.riskLevel.getNotes(),
      ...this.structureDescription.getNotes(),
      ...this.areas.getNotes()
    ];
  }
}
